import { __decorate, __metadata } from "tslib";
import { IsBoolean, Length } from 'class-validator';
/**
 * Requirements for documents to be attached when placing an order
 */
export class SupportingDocumentsConfiguration {
    /**
     * @param prompt Describes to the user, in plain text, that they should attach documents with their order,
     * and describes what they are
     * @param areEnabled Indicates whether documents can be attached when placing an order (currently only implemented for
     * transcript orders)
     * @param areRequired Indicate whether the user will be blocked from placing their order
     * before they upload any documents
     */
    constructor(prompt, areEnabled, areRequired) {
        this.prompt = prompt;
        this.areEnabled = areEnabled;
        this.areRequired = areRequired;
    }
}
SupportingDocumentsConfiguration.MAX_PROMPT_LENGTH = 500;
__decorate([
    Length(0, SupportingDocumentsConfiguration.MAX_PROMPT_LENGTH),
    __metadata("design:type", String)
], SupportingDocumentsConfiguration.prototype, "prompt", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], SupportingDocumentsConfiguration.prototype, "areEnabled", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], SupportingDocumentsConfiguration.prototype, "areRequired", void 0);
export const DEFAULT_AUDIO_SUPPORTING_DOCUMENTS = new SupportingDocumentsConfiguration('Attach any relevant supporting documents.', true, false);
export const DEFAULT_TRANSCRIPT_SUPPORTING_DOCUMENTS = new SupportingDocumentsConfiguration('Attach any relevant supporting documents.', true, true);
